import { Module } from "vuex";
import { State } from "@/store/modules/wine/state";
import Mutations from "@/store/modules/wine/mutations";
import Getters from "@/store/modules/wine/getters";
import Actions from "@/store/modules/wine/actions";

export class Wine implements Module<State, any> {
  namespaced: boolean = true;
  state: State;
  mutations = Mutations;
  getters = Getters;
  actions = Actions;

  // Setup CRUD operations
  constructor() {
    this.state = new State();
  }
}
